import ParamsSign from "@legos/js-security-v3/dist";

class CcoSecurity {
  constructor() {
    this.curPSignIns = null;
    this.appId = null;
  }
  getPSign(appId) {
    if (appId && this.appId !== appId) {
      this.appId = appId;
      this.curPSignIns = this.instancePSign(appId);
    }
    return this.curPSignIns;
  }
  instancePSign(appId) {
    const pSign = new ParamsSign({
      appId: appId, //验签ID，请参考接入步骤2申请验签ID
      debug: true, //测试时开启调试，切记：上线后设置为false。
      preRequest: true,
      onSign: ({ code }) => {
        // 签名可用率监控，业务方自行上报
        //   0: 成功
        //   1: 参数错误
        //   2: 缺少appId
        //   3: 获取token失败
        //   4: 签名失败
        //  -1: 其他错误
        console.log("onSignonSign-----", code);
      },
      onRequestTokenRemotely: ({ code, message }) => {
        //算法接口可用率监控，业务方自行上报
        // 200: 请求成功，表示动态算法接口请求成功，获取到动态token
        // 其他: 请求失败
        console.log("onRequestTokenRemotely-----", code, message);
      },
      onRequestToken: ({ code, message }) => {
        //token的可用率监控，业务方自行上报
        // 0: 动态token
        // 1:本地token
        console.log("onRequestToken-----", code, message);
      },
    });
    return pSign;
  }
}

const CcoSecurityIns = new CcoSecurity();

export default CcoSecurityIns;
// const PSign = new ParamsSign({
//   appId: "1007", //验签ID，请参考接入步骤2申请验签ID
//   debug: true, //测试时开启调试，切记：上线后设置为false。
//   preRequest: true,
//   onSign: ({
//     code
//   }) => { // 签名可用率监控，业务方自行上报
//     //   0: 成功
//     //   1: 参数错误
//     //   2: 缺少appId
//     //   3: 获取token失败
//     //   4: 签名失败
//     //  -1: 其他错误
//     console.log("onSignonSign-----", code)
//   },
//   onRequestTokenRemotely: ({
//     code,
//     message
//   }) => { //算法接口可用率监控，业务方自行上报
//     // 200: 请求成功，表示动态算法接口请求成功，获取到动态token
//     // 其他: 请求失败
//     console.log("onRequestTokenRemotely-----", code, message)
//   },
//   onRequestToken: ({
//     code,
//     message
//   }) => { //token的可用率监控，业务方自行上报
//     // 0: 动态token
//     // 1:本地token
//     console.log("onRequestToken-----", code, message)
//   }
// });

// //业务请求参数
// const params = {
//   pin: "jd_dfdfd9re420r434",
//   phone: "+8612345678900",
//   email: "xxx@qq.com"
// };

// //构造加签参数
// const paramsSign = {};
// paramsSign['phone'] = params['phone']
// paramsSign['email'] = params['email']

// //调用加签函数
// window.PSign.sign(paramsSign).then(signedParams => {
//   params.h5st = signedParams.h5st; //h5st字段为base64编码，可能包含特殊字符，get请求需要urlencode。
//   params._stk = signedParams._stk; //签名使用参数key列表
//   console.log("params=====", params);

//   //业务请求
//   //this.request('get', 'http://test-cactus.jd.local/verifySign', params)//该接口可做测试验证验签是否成功,状态码result:200即为成功，否则异常，异常状态码见下面状态码详述。仅作示例。
//   // { data: {result: 200},
//   //   result: 200,
//   //   message: "",
//   //   status: 200,
//   // }
// });